export const typeOptions = [
  { label: 'New', value: 'new' },
  { label: 'Renew', value: 'renew' },
];

export const deltaCertificatesTypeOptions = [
  { label: 'New', value: 'new' },
  { label: 'Renew', value: 'renew' },
];

export const visibilityOptions = [
  { label: 'Visible', value: true },
  { label: 'Not visible', value: false },
];

export const holderAuthorizeOptions = [
  { label: 'Authorized', value: true },
  { label: 'Not authorized', value: false },
];

export const deltaClassOptions = [
  { label: '1', value: 1 },
  { label: '2', value: 2 },
  { label: '3', value: 3 },
  { label: '4', value: 4 },
  { label: '5', value: 5 },
];

export const statusOptions = [
  { label: 'Active', value: 1 },
  { label: 'Withdraw By Holder', value: 2 },
  { label: 'Withdraw By CB', value: 3 },
];

export const yesNoBoolOptions = [
  { label: 'Yes', value: true },
  { label: 'No', value: false },
];

export const agreementStatusOptions = [
  { label: 'Active', value: 'Active' },
  { label: 'Suspended', value: 'Suspended' },
];

export const organizationStatusOptions = [
  { label: 'Active', value: true },
  { label: 'Suspended', value: false },
];

export const organizationIndustryOptions = [
  { label: 'Bank and Finance', value: 'Bank and Finance' },
  { label: 'Oil and gas', value: 'Delta' },
  { label: 'Construction and real estate', value: 'Construction and real estate' },
  { label: 'Telecommunication and IT', value: 'Telecommunication and IT' },
  { label: 'Government and public sector', value: 'Government and public sector' },
  { label: 'Hospitality and tourism', value: 'Hospitality and tourism' },
  { label: 'Education', value: 'Education' },
  { label: 'Consulting', value: 'Consulting' },
  { label: 'FMCG and Retail', value: 'FMCG and Retail' },
  { label: 'Agriculture and food processing', value: 'Agriculture and food processing' },
  { label: 'Manufacturing', value: 'Manufacturing' },
  { label: 'Other', value: 'Other' },
];

export const organizationTypeOptions = [
  { label: 'None', value: 'None' },
  { label: 'Delta', value: 'Delta' },
  { label: 'GC', value: 'GC' },
  { label: 'Both', value: 'Both' },
];

export const organizationSizeOptions = [
  { label: 'Basic', value: 'Basic' },
  { label: 'Medium', value: 'Medium' },
  { label: 'Complex', value: 'Complex' },
  { label: 'Extensive', value: 'Extensive' },
];

export const titleOptions = [
  { label: 'Mr', value: 'Mr' },
  { label: 'Mrs', value: 'Mrs' },
];

export const queryTypeOptions = [
  { label: 'Issue date', value: 'issueDate' },
  { label: 'Valid until', value: 'validUntil' },
];

export const compliantStatusOptions = [
  { value: 'No status', label: 'No status' },
  { value: 'Compliant', label: 'Compliant' },
  { value: 'Non-compliant', label: 'Non-compliant' },
];

export const qualityStatusOptions = [
  { value: 'No status', label: 'No status' },
  { value: 'Good quality', label: 'Good quality' },
  { value: 'Average quality', label: 'Average quality' },
  { value: 'To be improved', label: 'To be improved' },
];

export const performanceStatusOptions = [
  { value: 'No status', label: 'No status' },
  { value: 'Outperforming', label: 'Outperforming' },
  { value: 'Performing', label: 'Performing' },
  { value: 'More or less performing', label: 'More or less performing' },
  { value: 'Underperforming', label: 'Underperforming' },
];

export const viabilityOptions = [
  { value: 'No status', label: 'No status' },
  { value: 'Very viable', label: 'Very viable' },
  { value: 'Viable', label: 'Viable' },
  { value: 'More or less viable', label: 'More or less viable' },
  { value: 'Not viable', label: 'Not viable' },
];

export const stabilityOptions = [
  { value: 'No status', label: 'No status' },
  { value: 'Very stable', label: 'Very stable' },
  { value: 'Stable', label: 'Stable' },
  { value: 'More or less stable', label: 'More or less stable' },
  { value: 'Unstable', label: 'Unstable' },
];

export const yesNoOptions = [
  { value: 0, label: 'No' },
  { value: 1, label: 'Yes' },
];

export const signatureTypeOptions = [
  { label: 'None', value: 'N' },
  { label: 'Italic', value: 'I' },
  { label: 'Handwritten', value: 'H' },
];

export const roleOptions = [
  { label: 'Assessor', value: 'CB_ASSESSOR' },
  { label: 'CB Head', value: 'HEAD_OF_CB' },
];
